import { BrandFeatureName, FeatureName, PublicConfiguration } from '../models';

export class FeatureFlippingManagerBaseService {
  constructor(private configBase: PublicConfiguration) {}

  isFeatureActivated(feature: FeatureName): boolean {
    return this.configBase.features.includes(feature);
  }

  isBrandFeatureActivated(brandId: string, feature: BrandFeatureName): boolean {
    return !!this.configBase.fitterBrands
      ?.find((brand) => brand.id === brandId)
      ?.features.includes(feature);
  }

  brandFeatureActivatedExists(feature: BrandFeatureName): boolean {
    return !!this.configBase.fitterBrands.some((brand) =>
      brand.features.includes(feature)
    );
  }

  sendRequestNotificationOnlyToCustomer(brandId: string) {
    const brandRequestVersion = this.configBase.fitterBrands?.find(
      (brand) => brand.id === brandId
    )?.booking?.request?.version;
    return (
      !this.isFeatureActivated('send-supervisors-link-after-request') &&
      !this.isBrandFeatureActivated(
        brandId,
        'send-fitter-link-after-request'
      ) &&
      brandRequestVersion === 'MOCK'
    );
  }
}
